import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IGLAccountState } from './accounting.types';
import { IGLAccountData } from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IGLAccountState = {
  version: 1,
  accounts: [] as IGLAccountData[]
};

const namespaced = true;

export const accounting: Module<IGLAccountState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
